var React = require('react');

function Create (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50.75 19.3334H35.5008L37.7967 8.28925L37.8692 7.51591C37.8692 6.52508 37.4583 5.60675 36.8058 4.95425L34.2442 2.41675L18.3425 18.3426C17.4483 19.2126 16.9167 20.4209 16.9167 21.7501V45.9167C16.9167 48.5751 19.0917 50.7501 21.75 50.7501H43.5C45.5058 50.7501 47.2216 49.5418 47.9466 47.8018L55.245 30.7642C55.4625 30.2084 55.5833 29.6284 55.5833 29.0001V24.1667C55.5833 21.5084 53.4083 19.3334 50.75 19.3334ZM50.75 29.0001L43.5 45.9167H21.75V21.7501L32.2383 11.2617L29.5558 24.1667H50.75V29.0001ZM2.41666 21.7501H12.0833V50.7501H2.41666V21.7501Z"}));
}

Create.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none"};

module.exports = Create;

Create.default = Create;
